export default "__VITE_PUBLIC_ASSET__e11b6868__"